import React from 'react';
import { FEATURE_FLAG_DEFAULTS } from './feature-flags';

const AppContext = React.createContext({});
const FeatureFlagContext = React.createContext(FEATURE_FLAG_DEFAULTS);

export default AppContext;
export { AppContext, FeatureFlagContext };
